export const SETTINGS_SECTIONS = {
    searchResults: 'Search & results',
    selectorFields: 'Selector fields',
    storefrontText: 'Storefront text',
    appearance: 'Appearance',
    fitmentDataSources: 'Fitment data sources',
    productAttributes: 'Product attributes',
    shopifySync: 'Shopify sync',
    vendorIntegrations: 'Vendor integrations',
    advanced: 'Advanced',
    plan: 'Plan',
} as const;
